export default {
    Validations: {
        User: {
            fname: "First name is required",
            lname: "Last name is required",
            userid: "User ID is required",
            role: "User Role is required",
            password: "Password is required",
            passval: "Password should contain lowercase, uppercase and numeric charactors with the minimum length of 8",
            email: "Email is required",
            emailval: "Invalid email"
        }
    },
    Success:{
        User:{
            create:"Successfully created the user",
            update:"Successfully updated the user",
            updateProfile:"Successfully updated the profile",
            updatePassword:"Successfully updated the password",
            delete:"Successfully deleted the user"
        }
    },
    Failed:{
        User:{
            create: "Failed to create the user",
            update: "Failed to update the user",
            delete: "Failed to delete the user",
            updateProfile:"Failed to the profile",
            updatePassword:"Failed to update the password"
        }
    }
}
